"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tranSend = void 0;
var R_Send_1 = require("../src/core/transaction/R_Send");
var TranTypes_1 = require("../src/core/transaction/TranTypes");
var Account_1 = require("../src/core/account/Account");
var PrivateKeyAccount_1 = require("../src/core/account/PrivateKeyAccount");
var Base58_1 = require("../crypt/libs/Base58");
var Bytes_1 = require("../src/core/Bytes");
var base64_1 = require("../src/core/util/base64");
var crypt = require('../crypt/libs/aesCrypt');
exports.tranSend = function (recipient, keyPair, asset, body, port, genesis_sign, isBase64, transferType) {
    if (transferType === void 0) { transferType = TranTypes_1.ETransferType.DEFAULT; }
    return __awaiter(void 0, void 0, void 0, function () {
        var feePow, privateAccount, recipientAccount, messageBytes, isEncripted, isText, date, timestamp, reference, tx, bytes, raw, _a, size, fee, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 11, , 12]);
                    feePow = 0;
                    privateAccount = new PrivateKeyAccount_1.PrivateKeyAccount(keyPair);
                    recipientAccount = new Account_1.Account(recipient.address);
                    messageBytes = void 0;
                    isEncripted = new Int8Array([0]);
                    if (!(body.encrypted && recipient.publicKey)) return [3 /*break*/, 2];
                    return [4 /*yield*/, crypt.encryptMessage(body.message, recipient.publicKey, keyPair.secretKey)];
                case 1:
                    messageBytes = _b.sent();
                    isEncripted = new Int8Array([1]);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(body.message)];
                case 3:
                    messageBytes = _b.sent();
                    _b.label = 4;
                case 4:
                    isText = new Int8Array([1]);
                    date = new Date();
                    timestamp = date.getTime();
                    reference = 0;
                    tx = new R_Send_1.R_Send(privateAccount, feePow, recipientAccount, asset.assetKey, asset.amount, body.head, messageBytes, isText, isEncripted, timestamp, reference, port, genesis_sign, transferType);
                    return [4 /*yield*/, tx.sign(privateAccount, false)];
                case 5:
                    _b.sent();
                    return [4 /*yield*/, tx.toBytes(true, null)];
                case 6:
                    bytes = _b.sent();
                    if (!isBase64) return [3 /*break*/, 7];
                    _a = base64_1.default.encodeFromByteArray(new Uint8Array(bytes));
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, Base58_1.Base58.encode(bytes)];
                case 8:
                    _a = _b.sent();
                    _b.label = 9;
                case 9:
                    raw = _a;
                    return [4 /*yield*/, tx.getDataLength(false)];
                case 10:
                    size = _b.sent();
                    fee = (size * 100.0) / Math.pow(10, 8);
                    size = size;
                    return [2 /*return*/, {
                            raw: raw,
                            size: size,
                            fee: fee,
                        }];
                case 11:
                    e_1 = _b.sent();
                    return [2 /*return*/, {
                            raw: '',
                            size: 0,
                            fee: 0,
                            error: e_1,
                        }];
                case 12: return [2 /*return*/];
            }
        });
    });
};
